<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;color: #e06c24;">传道授业，共同成长</p>

        <p class="font2" style="padding-top: 4vh;">2024年您的线下授课时数共计<a class="font3">{{ this.totalHours }}</a>小时：</p>

        <p class="font2" style="padding-top: 2vh;"  v-for="(char, index) in lessonArray" :key="index">
            <a class="font3">{{ char.class_type }}</a>类课程
            <a class="font3">{{ char.class_num }}</a>门
            <a class="font3">{{ char.hours }}</a>小时，
            <a class="font3">{{ char.student_num }}</a>人参与
        </p>
        <p class="font2" style="padding-top: 4vh;margin: 0;">你的每一份付出都在传递智慧与力量</p>
        <p class="font2" style="margin: 0;">知识传播是一种美德</p>
        <p class="font2" style="margin: 0;">不仅成就了他人</p>
        <p class="font2" style="margin: 0;">而且提升了自己</p>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    data(){
        return{
            lessonArray:[],
            totalHours:0,
            classType:'',
            sutdentNum:0,
        }
    },
    created() {
        this.lessonArray = JSON.parse(this.ReportData.lesson)
        // console.log(this.lessonArray,'课程')
        this.lessonArray.forEach(element => {
        this.totalHours+=parseInt(element.hours)
        });
    }
}
</script>
  
<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24June/logo.png") right  top  no-repeat,
                url("../../assets//24February/icon.png") 49% calc(100% + 30px) no-repeat,
                url("../../assets/24June/bg1.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px, 68%,cover;
    width: 100%;
    height: 100vh;
}
.font1 {
    width: 92%;
    padding-left: 8%;
    margin: 0;
    text-align: left;
    font-size: 18px;
    color: #000;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 92%;
    padding-left: 8%;
    margin: 0;
    color: #000;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-weight: bolder;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
  </style>